module.exports = __webpack_public_path__ + "media/click.8b81c63b.wav";